import { render, staticRenderFns } from "./delivery-transam.vue?vue&type=template&id=d177ef00"
import script from "./delivery-transam.vue?vue&type=script&lang=js"
export * from "./delivery-transam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports